module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "workOrder"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "order_detail"
  }, [_c('div', {
    staticClass: "order_detail-box"
  }, [_c('div', {
    staticClass: "order_detail-title"
  }, [_vm._v("工单咨询详情"), (_vm.showInfo.orderState === 3) ? _c('span', {
    staticClass: "order_detail-span"
  }, [_vm._v("(该工单已关闭，不支持回复，谢谢)")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "replay_title"
  }, [_vm._v("回复工单")])]), _vm._v(" "), _c('div', {
    staticClass: "order_detail-box"
  }, [_c('div', {
    staticClass: "order_detail-info"
  }, [_c('div', {
    staticClass: "text_item"
  }, [_c('span', [_vm._v("工单id: ")]), _vm._v(_vm._s(_vm.showInfo.userRepairOrderId))]), _vm._v(" "), _c('div', {
    staticClass: "text_item"
  }, [_c('span', [_vm._v("工单标题:")]), _vm._v(" " + _vm._s(_vm.showInfo.orderTitle))]), _vm._v(" "), _c('div', {
    staticClass: "text_item"
  }, [_c('span', [_vm._v("工单内容:")]), _vm._v(" " + _vm._s(_vm.showInfo.orderContent))]), _vm._v(" "), _c('div', {
    staticClass: "text_item"
  }, [_c('span', [_vm._v("工单创建时间:")]), _vm._v(" " + _vm._s(_vm.showInfo.createtime))]), _vm._v(" "), _c('div', {
    staticClass: "text_item"
  }, [_c('span', [_vm._v("工单更新时间:")]), _vm._v(" " + _vm._s(_vm.showInfo.updatetime || '暂无'))]), _vm._v(" "), _c('div', {
    staticClass: "text_item"
  }, [_c('span', [_vm._v("工单处理人名称:")]), _vm._v(" " + _vm._s(_vm.showInfo.fullname || '暂无'))]), _vm._v(" "), _c('div', {
    staticClass: "text_item"
  }, [_c('span', [_vm._v("工单状态:")]), _vm._v(" " + _vm._s(_vm.stateMap[_vm.showInfo.orderState]))])]), _vm._v(" "), _c('div', {
    staticClass: "order_detail-info"
  }, [_c('el-form', {
    ref: "ruleForm",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.ruleForm,
      "rules": _vm.rules,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    staticClass: "orderInput",
    attrs: {
      "label": "回复内容",
      "prop": "replyContent"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": _vm.showInfo.orderState === 3 ? true : false,
      "type": "textarea",
      "rows": 6,
      "placeholder": "请输入回复内容"
    },
    model: {
      value: (_vm.ruleForm.replyContent),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "replyContent", $$v)
      },
      expression: "ruleForm.replyContent"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "button_post"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.showInfo.orderState === 3 ? true : false
    },
    on: {
      "click": function($event) {
        return _vm.submitForm('ruleForm')
      }
    }
  }, [_vm._v("立即回复")])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "order_detail-title order_reply"
  }, [_vm._v("工单回复详情")]), _vm._v(" "), _c('el-table', {
    staticClass: "order_table",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.replyList
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "回复人名称",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.userRepairReplyName || '我'))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "replyContent",
      "label": "回复内容",
      "align": "center",
      "width": "300"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createtime",
      "label": "回复时间",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "center",
      "min-width": "40"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleClick(scope.row)
            }
          }
        }, [_vm._v("详情")])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [(_vm.replyList.length > 0) ? _c('el-pagination', {
    attrs: {
      "current-page": _vm.currentPage,
      "page-size": 10,
      "layout": "total, prev, pager, next",
      "total": _vm.totalCount
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "工单回复详情",
      "visible": _vm.dialogTableVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogTableVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "replay_text_item"
  }, [_c('span', [_vm._v("回复人名称:")]), _vm._v(" " + _vm._s(_vm.replayForm.userRepairReplyName || '我'))]), _vm._v(" "), _c('div', {
    staticClass: "replay_text_item"
  }, [_c('span', [_vm._v("回复内容:")]), _vm._v(" " + _vm._s(_vm.replayForm.replyContent))]), _vm._v(" "), _c('div', {
    staticClass: "replay_text_item"
  }, [_c('span', [_vm._v("回复时间: ")]), _vm._v(_vm._s(_vm.replayForm.createtime))])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1586d19c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/personalCenter/workOrderDetails.vue
// module id = 1053
// module chunks = 1